import config from 'config';

import { ConfigType } from './config.type';

function getConfig() {
  return config as unknown as ConfigType;
}

export { getConfig };
